import { POST_CHECKIN_UI_BUILDER_MOBILE_MENU } from '../../constants/UiBuilderConst';
import { decryptLocalStorage } from '../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../utils/loaderSlice';
import { notificationManager } from '../../utils/NotificationUtils';

export const handleOnDragEnd = (
  result,
  setVisible,
  placeHolder,
  setPlaceHolder,
  isChannel = false,
  page = 0,
  rowsPerPage = null,
) => {
  if (!result.destination) return;
  const offset = rowsPerPage && rowsPerPage > 0 ? page * rowsPerPage : 0;

  const globalSourceIndex = result.source.index + offset;
  const globalDestIndex = result.destination.index + offset;

  const items = Array.from(placeHolder);
  const [reorderedItem] = items?.splice(globalSourceIndex, 1);
  items.splice(globalDestIndex, 0, reorderedItem);
  let tempChannels = [...items];
  if (isChannel) {
    tempChannels = items?.map((e, index) => ({
      ...e,
      number: (index + 1).toString(),
    }));
    setPlaceHolder(tempChannels);
  } else {
    setPlaceHolder(items);
  }

  setVisible(true);
  document.body.classList.add('popup-active');
};

export const handleSave = (
  dispatch,
  setGlobalPlaceHolder,
  placeHolder,
  mappingApi,
  setPopUp,
  setVisible,
  setPlaceHolder,
  globalPlaceHolder,
  displayText,
  globalCategoryPlaceHolder,
  globalRoomTypePlaceHolder,
  module,
  nestedStatus,
  setNestedStatus,
  setExpanded,
) => {
  dispatch(stepUpLoaderCount());
  const lang = decryptLocalStorage('lang');
  const selectedLang = lang !== 'en' ? lang : '';
  let temporaryObject = {};
  placeHolder?.forEach((item, index) => {
    temporaryObject[item?.id] = index;
  });
  let payload = {
    hotelId: nestedStatus
      ? placeHolder[0]?.hotelId + '#' + placeHolder[0]?.categoryId
      : placeHolder[0]?.hotelId,
    jsonResponse: JSON.stringify(temporaryObject),
    module: module,
  };

  if (module === 'TV_CHANNEL') {
    payload = {
      hotelId: placeHolder[0]?.hotelId,
      channels: placeHolder?.map((channel) => {
        return { channelID: channel?.id, channelNumber: channel?.number };
      }),
    };
  }
  mappingApi(payload, selectedLang)
    .then((res) => {
      setPopUp(false);
      setVisible(false);
      let data = { ...globalPlaceHolder };
      if (displayText === 'Hamburger menu') {
        module === POST_CHECKIN_UI_BUILDER_MOBILE_MENU
          ? (data = { ...data, post: placeHolder })
          : (data = { ...data, pre: placeHolder });

        dispatch(setGlobalPlaceHolder(data));
      } else {
        if (Array?.isArray(globalPlaceHolder)) {
          const updatedDirectoriesList = placeHolder?.map((directory) => {
            const isChecked = globalPlaceHolder?.some(
              (item) => item.id === directory?.id && item?.isChecked,
            );
            return { ...directory, isChecked };
          });

          if (displayText === 'Accommodations room type') {
            updatedDirectoriesList.forEach((directory) => {
              if (directory?.isChecked && Array?.isArray(globalRoomTypePlaceHolder)) {
                const roomTypeIndex = globalRoomTypePlaceHolder?.findIndex(
                  (roomType) => roomType?.id === directory?.id,
                );
                if (roomTypeIndex !== -1) {
                  globalRoomTypePlaceHolder[roomTypeIndex].isChecked = true;
                }
              }
            });
          }

          dispatch(setGlobalPlaceHolder(updatedDirectoriesList));
        } else {
          dispatch(setGlobalPlaceHolder(placeHolder));
        }
      }
      setNestedStatus && setNestedStatus(false);
      notificationManager('success', displayText + ' sorted successfully');
    })
    .catch((err) => {
      setPopUp(false);
      setVisible(false);
      if (
        displayText === 'Accommodations room type' ||
        displayText === 'City guide' ||
        displayText === 'Hotel Compendium'
      ) {
        if (Array?.isArray(globalPlaceHolder) && Array?.isArray(globalCategoryPlaceHolder)) {
          const list = globalPlaceHolder.map((obj) => {
            const catObj = globalCategoryPlaceHolder.find((c) => c.id === obj.categoryId);

            return {
              ...obj,
              category: catObj ? catObj.name : '',
            };
          });
          setPlaceHolder(list);
        }
      } else if (displayText === 'Accommodations room') {
        if (
          Array?.isArray(globalPlaceHolder) &&
          Array?.isArray(globalCategoryPlaceHolder) &&
          Array?.isArray(globalRoomTypePlaceHolder)
        ) {
          const list = globalPlaceHolder.map((obj) => {
            const catObj = globalCategoryPlaceHolder.find((c) => c.id === obj.categoryId);
            const roomTypeObj = globalRoomTypePlaceHolder.find((r) => r.id === obj.roomTypeId);
            return {
              ...obj,
              category: catObj ? catObj.name : '',
              roomType: roomTypeObj ? roomTypeObj.name : '',
            };
          });
          setPlaceHolder(list);
        }
      } else if (displayText === 'Hamburger menu') {
        module === POST_CHECKIN_UI_BUILDER_MOBILE_MENU
          ? setPlaceHolder(globalPlaceHolder?.post)
          : setPlaceHolder(globalPlaceHolder?.pre);
      } else {
        if (Array?.isArray(globalPlaceHolder)) {
          const updatedDirectoriesList = placeHolder?.map((directory) => {
            const isChecked = globalPlaceHolder?.some(
              (item) => item?.id === directory?.id && item?.isChecked,
            );
            return { ...directory, isChecked };
          });
          setPlaceHolder(updatedDirectoriesList);
        } else {
          setPlaceHolder(placeHolder);
        }
      }
      setNestedStatus && setNestedStatus(false);
      setExpanded && setExpanded([]);
      notificationManager('danger', 'Failed to save the changes');
    })
    .finally(() => {
      dispatch(stepDownLoaderCount());
    });
};

export const handleCancel = (
  setPopUp,
  setVisible,
  setPlaceHolder,
  globalPlaceHolder,
  globalCategoryPlaceHolder,
  globalRoomTypePlaceHolder,
  displayText,
  setExpanded,
  setDrag,
  module,
  placeHolder,
) => {
  const resetCheckedItems = () => {
    if (Array?.isArray(globalPlaceHolder)) {
      return globalPlaceHolder.map((directory) => {
        return { ...directory, isChecked: false };
      });
    }
    return Array?.isArray(placeHolder)
      ? placeHolder?.map((item) => ({ ...item, isChecked: false }))
      : [];
  };

  setPopUp(false);
  setVisible(false);
  if (
    displayText === 'Accommodations room type' ||
    displayText === 'City guide' ||
    displayText === 'Hotel Compendium'
  ) {
    if (Array?.isArray(globalPlaceHolder) && Array?.isArray(globalCategoryPlaceHolder)) {
      const list = globalPlaceHolder.map((obj) => {
        const catObj = globalCategoryPlaceHolder.find((c) => c.id === obj.categoryId);

        return {
          ...obj,
          category: catObj ? catObj.name : '',
        };
      });
      setPlaceHolder(list);
    }
  } else if (displayText === 'Accommodations room') {
    if (
      Array?.isArray(globalPlaceHolder) &&
      Array?.isArray(globalCategoryPlaceHolder) &&
      Array?.isArray(globalRoomTypePlaceHolder)
    ) {
      const list = globalPlaceHolder?.map((obj) => {
        const catObj = globalCategoryPlaceHolder?.find((c) => c.id === obj.categoryId);
        const roomTypeObj = globalRoomTypePlaceHolder?.find((r) => r.id === obj.roomTypeId);
        return {
          ...obj,
          category: catObj ? catObj.name : '',
          roomType: roomTypeObj ? roomTypeObj.name : '',
        };
      });
      setPlaceHolder(list);
    }
  } else if (displayText === 'Hamburger menu') {
    module === POST_CHECKIN_UI_BUILDER_MOBILE_MENU
      ? setPlaceHolder(globalPlaceHolder?.post)
      : setPlaceHolder(globalPlaceHolder?.pre);
  } else {
    const updatedPlaceHolder = resetCheckedItems();
    setPlaceHolder(updatedPlaceHolder);
  }
  setPopUp(false);
  setVisible(false);
  setExpanded && setExpanded([]);
  setDrag && setDrag(false);
};
